var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99992 0.666626C1.52925 0.666626 0.333252 1.86263 0.333252 3.33329V24.6666C0.333252 26.1373 1.52925 27.3333 2.99992 27.3333H11.9114C11.334 26.12 10.9999 24.7666 10.9999 23.3333C10.9999 22.5186 11.1151 21.7325 11.3124 20.9791L6.99992 16.6666L2.99992 20.6666V3.33329H12.3333V9.99996H18.9999V14.1041C19.4359 14.0415 19.8799 13.9974 20.3333 13.9974C20.7866 13.9974 21.2306 14.0415 21.6666 14.1041V8.66663L13.6666 0.666626H2.99992ZM13.6666 12.6666C13.313 12.6666 12.9738 12.8071 12.7238 13.0572C12.4737 13.3072 12.3333 13.6463 12.3333 14C12.3333 14.3536 12.4737 14.6927 12.7238 14.9428C12.9738 15.1928 13.313 15.3333 13.6666 15.3333C14.0202 15.3333 14.3593 15.1928 14.6094 14.9428C14.8594 14.6927 14.9999 14.3536 14.9999 14C14.9999 13.6463 14.8594 13.3072 14.6094 13.0572C14.3593 12.8071 14.0202 12.6666 13.6666 12.6666ZM20.3333 16.6666C16.6519 16.6666 13.6666 19.652 13.6666 23.3333C13.6666 27.0146 16.6519 30 20.3333 30C24.0146 30 26.9999 27.0146 26.9999 23.3333C26.9999 19.652 24.0146 16.6666 20.3333 16.6666ZM18.9999 19.3333H21.6666V22H24.3333V24.6666H21.6666V27.3333H18.9999V24.6666H16.3333V22H18.9999V19.3333Z",
    fill: "#2484BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.24afa955526b7e371c9105f2b9ce513f.svg";
export { ForwardRef as ReactComponent };